// extracted by mini-css-extract-plugin
export var Sidebar = "Sidebar-module--Sidebar--hiZxs";
export var Logo = "Sidebar-module--Logo--3FiKG";
export var IntroPages = "Sidebar-module--IntroPages--1h022";
export var PageLink = "Sidebar-module--PageLink--2kDeq";
export var SelectedPage = "Sidebar-module--SelectedPage--3f_ii";